import { render, staticRenderFns } from "./NavbarV.vue?vue&type=template&id=58a1d158"
import script from "./NavbarV.vue?vue&type=script&lang=js"
export * from "./NavbarV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports